var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgModeleEmailIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_73_18)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.45004 7.33642C9.49309 7.22554 9.56864 7.13027 9.66679 7.06309C9.76494 6.99591 9.8811 6.95996 10 6.95996C10.119 6.95996 10.2351 6.99591 10.3333 7.06309C10.4314 7.13027 10.507 7.22554 10.55 7.33642L11.19 8.96642H12.9C13.0216 8.96821 13.1399 9.00629 13.2397 9.07578C13.3395 9.14528 13.4162 9.243 13.46 9.35642C13.5024 9.46822 13.5097 9.59023 13.4811 9.70631C13.4526 9.82238 13.3894 9.92704 13.3 10.0064L11.79 11.3564L12.43 12.6364C12.488 12.7488 12.5076 12.877 12.4859 13.0016C12.4643 13.1261 12.4025 13.2402 12.31 13.3264C12.2182 13.4137 12.1015 13.4703 11.976 13.4882C11.8506 13.5061 11.7227 13.4845 11.61 13.4264L10 12.5164L8.39004 13.3964C8.27743 13.4545 8.14952 13.4761 8.02407 13.4582C7.89863 13.4403 7.78188 13.3837 7.69004 13.2964C7.59757 13.2102 7.5358 13.0961 7.51414 12.9716C7.49247 12.847 7.5121 12.7188 7.57004 12.6064L8.21004 11.3264L6.70004 9.96642C6.61066 9.88704 6.5475 9.78238 6.51893 9.66631C6.49036 9.55023 6.49772 9.42822 6.54004 9.31642C6.58994 9.21048 6.66928 9.12115 6.76858 9.05909C6.86788 8.99702 6.98295 8.96485 7.10004 8.96642H8.81004L9.45004 7.33642Z",
    stroke: "black",
    strokeOpacity: 0.501961,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 9.5H1.5C1.23478 9.5 0.98043 9.39464 0.792893 9.20711C0.605357 9.01957 0.5 8.76522 0.5 8.5V1.5C0.5 1.23478 0.605357 0.98043 0.792893 0.792893C0.98043 0.605357 1.23478 0.5 1.5 0.5H11.5C11.7652 0.5 12.0196 0.605357 12.2071 0.792893C12.3946 0.98043 12.5 1.23478 12.5 1.5V5.5",
    stroke: "black",
    strokeOpacity: 0.501961,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.5 1.76001L6.5 6.00001L12.5 1.76001",
    stroke: "black",
    strokeOpacity: 0.501961,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_73_18"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModeleEmailIcon);
export default __webpack_public_path__ + "static/media/modele_email_icon.99e2a2a775d76daef725fa6ae50b2948.svg";
export { ForwardRef as ReactComponent };